import React, { Component } from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import Menu from '../Home/Menu'
import Modules from '../Home/Modules'
import Contenu from '../Contenu/Contenu'
import ContenuRubrique from '../Contenu/ContenuRubrique'
import ContenuCategorie from '../Contenu/ContenuCategorie'
import ContenuPage from '../Contenu/ContenuPage'
import Icons from '../Home/Icons'
import Rubrics from '../Rubrics/Rubrics'
import AnimationDates from '../Animations/Dates'
import AnimationCategories from '../Animations/Categories'
import Animations from '../Animations/Animations'
import Bookings from '../Services/Bookings'
import BackUsers from '../Users/BackUsers'
import MessagerieAll from '../Messages/MessagerieAll'
import MessagerieParam from '../Messages/MessagerieParam'
import Clients from '../Users/Clients'
import CronMail from '../Emails/CronMail'
import CheckinsParam from '../Checkins/CheckinsParam'
import CheckinsStats from '../Checkins/CheckinsStats'
import DepositParam from '../Checkins/DepositParam'
import InterventionsApp from '../Interventions/InterventionsApp'
import FieldInventoriesApp from '../Inventory/Field/FieldInventoriesApp'
import LocationsPage from '../Locations/LocationsPage'
import StayArrivals from '../Checkins/StayArrivals'
import UsersDeposit from '../Checkins/UsersDeposit'
import Email from '../Emails/Email'
import DashboardUsers from '../Users/DashboardUsers'
import NewClients from '../Users/NewClients'
import Home from '../Home/Home'
import Inventory from '../Inventory/Inventory'
import Inventories from '../Inventory/Inventories'
import InventoryEdit from '../Inventory/InventoryEdit'
import Pdf from '../Home/Pdf'
import ReviewsAnswers from '../Reviews/Answers'
import ReviewsTemplate from '../Reviews/Template'
import Services from '../Services/Services'
import ServiceWizard from '../Services/ServiceWizard'
import ServiceDetail from '../Services/ServiceDetail'
import ServiceCommandes from '../Services/ServiceCommandes'
import ServiceCommandesAll from '../Services/ServiceCommandesAll'
import CashCalculator from '../Services/CashCalculator'
import SendEmail from '../Emails/SendEmail'
import SettingsUser from '../Settings/User'
import SettingsConfigAdmin from '../Settings/ConfigAdmin'
import SettingsConfigWebapp from '../Settings/ConfigWebapp'
import Pitches from '../Settings/Pitches'
import Stats from '../Home/Stats'
import Stays from '../Users/Stays'
import Users from '../Users/Users'
import NotificationHub from '../Emails/NotificationHub'
import Theme from '../Home/Theme'
import WebUsers from '../Users/WebUsers'
import './Main.css'

class Main extends Component {
	render() {
		return (
			<Route path={['/interventions', '/inventaires-terrain', '/parametres']}>
				{({ match }) => (
			<div className={match ? '' : 'wrapper'}>
				<Switch>
					<Route
						exact
						path="/icons"
						render={(props) =>
							<Icons
								{...props}
								updateNavbarTitle={this.props.updateNavbarTitle}
								fetchServiceProductsByService={this.props.fetchServiceProductsByService}
								insertServiceProduct={this.props.insertServiceProduct}
								updateServiceProduct={this.props.updateServiceProduct}
								deleteServiceProduct={this.props.deleteServiceProduct}
							/>}
					/>
					<Route
						exact
						path={['/interventions/:id', '/interventions']}
						render={(props) =>
							<InterventionsApp
								{...props}
								user={this.props.user}
								establishment={this.props.establishment}
								sidebarCollapsed={this.props.sidebar_collapsed}
							/>}
					/>
					<Route
						exact
						path={['/inventaires-terrain/tour/:id/:location/recap', '/inventaires-terrain/tour/:id/:location', '/inventaires-terrain/tour/:id', '/inventaires-terrain']}
						render={(props) =>
							<FieldInventoriesApp
								{...props}
								user={this.props.user}
							/>}
					/>
					<Route
						exact
						path="/parametres"
						render={(props) =>
							<SettingsUser
								{...props}
								user={this.props.user}
								updateUser={this.props.updateUser}
								updateNavbarTitle={this.props.updateNavbarTitle}
								onLogout={() => this.props.updateUser(null)}
								sidebarCollapsed={this.props.sidebar_collapsed}
								onToggleSidebar={this.props.onToggleSidebar}
								fetchServiceProductsByService={this.props.fetchServiceProductsByService}
								insertServiceProduct={this.props.insertServiceProduct}
								updateServiceProduct={this.props.updateServiceProduct}
								deleteServiceProduct={this.props.deleteServiceProduct}
							/>}
					/>
					<Route
						exact
						path="/contenu"
						render={(props) =>
							<Contenu
								{...props}
								user={this.props.user}
								langs={this.props.langs}
								lang_default={this.props.lang_default}
								modules={this.props.modules}
								updateModulesOrder={this.props.updateModulesOrder}
								updateModuleHidden={this.props.updateModuleHidden}
								insertGroup={this.props.insertGroup}
								insertPage={this.props.insertPage}
								insertCategory={this.props.insertCategory}
								insertList={this.props.insertList}
								insertModule={this.props.insertModule}
								deleteModule={this.props.deleteModule}
								deleteGroup={this.props.deleteGroup}
								deletePage={this.props.deletePage}
								fetchModules={this.props.fetchModules}
								fetchGroups={this.props.fetchGroups}
								fetchCategories={this.props.fetchCategories}
								fetchLists={this.props.fetchLists}
								fetchIcons={this.props.fetchIcons}
								fetchTheme={this.props.fetchTheme}
								updateNavbarTitle={this.props.updateNavbarTitle}
							/>}
					/>
					<Route
						exact
						path="/contenu/rubrique/:id"
						render={(props) =>
							<ContenuRubrique
								{...props}
								user={this.props.user}
								langs={this.props.langs}
								lang_default={this.props.lang_default}
								categories={this.props.categories}
								updateCategoriesOrder={this.props.updateCategoriesOrder}
								updateGroup={this.props.updateGroup}
								updateModule={this.props.updateModule}
								fetchGroups={this.props.fetchGroups}
								fetchCategoriesByGroup={this.props.fetchCategoriesByGroup}
								fetchCategories={this.props.fetchCategories}
								fetchModules={this.props.fetchModules}
								fetchIcons={this.props.fetchIcons}
								fetchTheme={this.props.fetchTheme}
								updateNavbarTitle={this.props.updateNavbarTitle}
							/>}
					/>
					<Route
						exact
						path="/contenu/categorie/:id"
						render={(props) =>
							<ContenuCategorie
								{...props}
								user={this.props.user}
								langs={this.props.langs}
								lang_default={this.props.lang_default}
								features={this.props.features}
								pages={this.props.pages}
								lists={this.props.lists}
								services={this.props.services}
								fetchCategories={this.props.fetchCategories}
								fetchGroups={this.props.fetchGroups}
								fetchIcons={this.props.fetchIcons}
								fetchTheme={this.props.fetchTheme}
								fetchPageByCategory={this.props.fetchPageByCategory}
								fetchPageByID={this.props.fetchPageByID}
								fetchListByCategory={this.props.fetchListByCategory}
								fetchServices={this.props.fetchServices}
								insertListElement={this.props.insertListElement}
								insertPage={this.props.insertPage}
								insertPageSection={this.props.insertPageSection}
								updateListCover={this.props.updateListCover}
								updateListElement={this.props.updateListElement}
								updateListOrderElements={this.props.updateListOrderElements}
								updateListTransformSubcategory={this.props.updateListTransformSubcategory}
								updatePageCover={this.props.updatePageCover}
								updatePageDuplicateSection={this.props.updatePageDuplicateSection}
								updatePageName={this.props.updatePageName}
								updatePageOrderSections={this.props.updatePageOrderSections}
								updatePageSection={this.props.updatePageSection}
								updatePageService={this.props.updatePageService}
								deleteListElement={this.props.deleteListElement}
								deletePage={this.props.deletePage}
								deletePageSection={this.props.deletePageSection}
								deletePageService={this.props.deletePageService}
								updateNavbarTitle={this.props.updateNavbarTitle}
							/>}
					/>
					<Route
						exact
						path="/contenu/page/:id"
						render={(props) =>
							<ContenuPage
								{...props}
								user={this.props.user}
								langs={this.props.langs}
								lang_default={this.props.lang_default}
								features={this.props.features}
								pages={this.props.pages}
								services={this.props.services}
								fetchIcons={this.props.fetchIcons}
								fetchTheme={this.props.fetchTheme}
								fetchPageByCategory={this.props.fetchPageByCategory}
								fetchPageByID={this.props.fetchPageByID}
								fetchServices={this.props.fetchServices}
								insertPageSection={this.props.insertPageSection}
								updatePageCover={this.props.updatePageCover}
								updatePageDuplicateSection={this.props.updatePageDuplicateSection}
								updatePageOrderSections={this.props.updatePageOrderSections}
								updatePageSection={this.props.updatePageSection}
								updatePageService={this.props.updatePageService}
								deletePageSection={this.props.deletePageSection}
								deletePageService={this.props.deletePageService}
								updateNavbarTitle={this.props.updateNavbarTitle}
							/>}
					/>
					<Route
						exact
						path="/modules"
						render={(props) =>
							<Modules
								{...props}
								user={this.props.user}
								langs={this.props.langs}
								lang_default={this.props.lang_default}
								modules={this.props.modules}
								insertModule={this.props.insertModule}
								updateModule={this.props.updateModule}
								updateModulesOrder={this.props.updateModulesOrder}
								deleteModule={this.props.deleteModule}
								fetchModules={this.props.fetchModules}
								fetchPages={this.props.fetchPages}
								fetchLists={this.props.fetchLists}
								fetchGroups={this.props.fetchGroups}
								fetchCategories={this.props.fetchCategories}
								updateNavbarTitle={this.props.updateNavbarTitle}
								fetchServiceProductsByService={this.props.fetchServiceProductsByService}
								insertServiceProduct={this.props.insertServiceProduct}
								updateServiceProduct={this.props.updateServiceProduct}
								deleteServiceProduct={this.props.deleteServiceProduct}
							/>}
					/>
					<Route
						exact
						path="/rubriques"
						render={(props) =>
							<Rubrics
								// properties
								{...props}
								user={this.props.user}
								features={this.props.features}
								categories={this.props.categories}
								groups={this.props.groups}
								langs={this.props.langs}
								lang_default={this.props.lang_default}
								pages={this.props.pages}
								lists={this.props.lists}
								services={this.props.services}

								// insert methods
								insertCategory={this.props.insertCategory}
								insertGroup={this.props.insertGroup}
								insertList={this.props.insertList}
								insertListElement={this.props.insertListElement}
								insertPage={this.props.insertPage}
								insertPageSection={this.props.insertPageSection}

								// update methods
								updateCategoriesOrder={this.props.updateCategoriesOrder}
								updateCategory={this.props.updateCategory}
								updateCategoryDuplicate={this.props.updateCategoryDuplicate}
								updateGroup={this.props.updateGroup}
								updateListCover={this.props.updateListCover}
								updateListElement={this.props.updateListElement}
								updateListOrderElements={this.props.updateListOrderElements}
								updateListTransformSubcategory={this.props.updateListTransformSubcategory}
								updatePageCover={this.props.updatePageCover}
								updatePageDuplicateSection={this.props.updatePageDuplicateSection}
								updatePageName={this.props.updatePageName}
								updatePageOrderSections={this.props.updatePageOrderSections}
								updatePageSection={this.props.updatePageSection}
								updatePageService={this.props.updatePageService}

								// delete methods
								deleteCategory={this.props.deleteCategory}
								deleteGroup={this.props.deleteGroup}
								deleteListByCategory={this.props.deleteListByCategory}
								deleteListElement={this.props.deleteListElement}
								deletePage={this.props.deletePage}
								deletePageByCategory={this.props.deletePageByCategory}
								deletePageSection={this.props.deletePageSection}
								deletePageService={this.props.deletePageService}

								// fetch methods
								fetchCategoriesByGroup={this.props.fetchCategoriesByGroup}
								fetchGroups={this.props.fetchGroups}
								fetchIcons={this.props.fetchIcons}
								fetchListByCategory={this.props.fetchListByCategory}
								fetchPageByID={this.props.fetchPageByID}
								fetchPageByCategory={this.props.fetchPageByCategory}
								fetchServices={this.props.fetchServices}
								fetchTheme={this.props.fetchTheme}

								// others
								updateNavbarTitle={this.props.updateNavbarTitle}
								fetchServiceProductsByService={this.props.fetchServiceProductsByService}
								insertServiceProduct={this.props.insertServiceProduct}
								updateServiceProduct={this.props.updateServiceProduct}
								deleteServiceProduct={this.props.deleteServiceProduct}
							/>}
					/>
					<Route
						exact
						path="/animation-categories"
						render={(props) => 
							<AnimationCategories
								{...props}
								user={this.props.user}
								langs={this.props.langs}
								lang_default={this.props.lang_default}
								categories={this.props.animationCategories}
								deleteAnimationCategory={this.props.deleteAnimationCategory}
								insertAnimationCategory={this.props.insertAnimationCategory}
								updateAnimationCategory={this.props.updateAnimationCategory}
								fetchAnimationCategories={this.props.fetchAnimationCategories}
								updateNavbarTitle={this.props.updateNavbarTitle}
								fetchServiceProductsByService={this.props.fetchServiceProductsByService}
								insertServiceProduct={this.props.insertServiceProduct}
								updateServiceProduct={this.props.updateServiceProduct}
								deleteServiceProduct={this.props.deleteServiceProduct}
							/>}
					/>
					<Route
						exact
						path="/animations"
						render={(props) =>
							<Animations
								{...props}
								user={this.props.user}
								animations={this.props.animations}
								categories={this.props.animationCategories}
								features={this.props.features}
								langs={this.props.langs}
								lang_default={this.props.lang_default}
								deleteAnimation={this.props.deleteAnimation}
								insertAnimation={this.props.insertAnimation}
								updateAnimation={this.props.updateAnimation}
								updateAnimationCategories={this.props.updateAnimationCategories}
								fetchAnimationDates={this.props.fetchAnimationDates}
								fetchAnimations={this.props.fetchAnimations}
								fetchAnimationByID={this.props.fetchAnimationByID}
								fetchAnimationCategories={this.props.fetchAnimationCategories}
								fetchAnimationFolders={this.props.fetchAnimationFolders}
								config_animations={this.props.config_animations}
								fetchConfigAnimations={this.props.fetchConfigAnimations}
								updateConfigAnimations={this.props.updateConfigAnimations}
								renameAnimationFolder={this.props.renameAnimationFolder}
								deleteAnimationFolder={this.props.deleteAnimationFolder}
								moveAnimationsToFolder={this.props.moveAnimationsToFolder}
								fetchServiceBenefits={this.props.fetchServiceBenefits}
								fetchServices={this.props.fetchServices}
								updateNavbarTitle={this.props.updateNavbarTitle}
								fetchServiceProductsByService={this.props.fetchServiceProductsByService}
								insertServiceProduct={this.props.insertServiceProduct}
								updateServiceProduct={this.props.updateServiceProduct}
								deleteServiceProduct={this.props.deleteServiceProduct}
							/>}
					/>
					<Route
						exact
						path="/animation-dates"
						render={(props) =>
							<AnimationDates
								{...props}
								user={this.props.user}
								animations={this.props.animations}
								categories={this.props.animationCategories}
								dates={this.props.animationDates}
								lang_default={this.props.lang_default}
								deleteAnimationDate={this.props.deleteAnimationDate}
								deleteAnimationDatesByRange={this.props.deleteAnimationDatesByRange}
								insertAnimationDates={this.props.insertAnimationDates}
								fetchAnimations={this.props.fetchAnimations}
								fetchAnimationDates={this.props.fetchAnimationDates}
								fetchAnimationCategories={this.props.fetchAnimationCategories}
								updateNavbarTitle={this.props.updateNavbarTitle}
								fetchServiceProductsByService={this.props.fetchServiceProductsByService}
								insertServiceProduct={this.props.insertServiceProduct}
								updateServiceProduct={this.props.updateServiceProduct}
								deleteServiceProduct={this.props.deleteServiceProduct}
							/>}
					/>
					<Route
						exact
						path="/services/new"
						render={(props) =>
							<ServiceWizard
								{...props}
								user={this.props.user}
								lang_default={this.props.lang_default}
								langs={this.props.langs}
								insertService={this.props.insertService}
								insertPicture={this.props.insertPicture}
								updateServiceDuration={this.props.updateServiceDuration}
								insertServiceWorker={this.props.insertServiceWorker}
								updateNavbarTitle={this.props.updateNavbarTitle}
								fetchServiceProductsByService={this.props.fetchServiceProductsByService}
								insertServiceProduct={this.props.insertServiceProduct}
								updateServiceProduct={this.props.updateServiceProduct}
								deleteServiceProduct={this.props.deleteServiceProduct}
							/>}
					/>
					<Route
						exact
						path="/services/booking"
						render={(props) =>
							<Bookings
								{...props}
								clients={this.props.clients}
								icons={this.props.icons}
								lang_default={this.props.lang_default}
								features={this.props.features}
								service_benefits={this.props.service_benefits}
								service_reservations={this.props.service_reservations}
								service_workers={this.props.service_workers}
								user={this.props.user}
								webapp_users={this.props.webapp_users}
								insertServiceReservation={this.props.insertServiceReservation}
								cancelServiceReservation={this.props.cancelServiceReservation}
							updateServiceReservation={this.props.updateServiceReservation}
								deleteServiceReservation={this.props.deleteServiceReservation}
								fetchClients={this.props.fetchClients}
								fetchReservationServices={this.props.fetchReservationServices}
								fetchServices={this.props.fetchServices}
								fetchServiceBenefits={this.props.fetchServiceBenefits}
								fetchServiceReservationsByService={this.props.fetchServiceReservationsByService}
								fetchReservationsByDateRange={this.props.fetchReservationsByDateRange}
								fetchServiceWorkers={this.props.fetchServiceWorkers}
								fetchWebappUsers={this.props.fetchWebappUsers}
								updateNavbarTitle={this.props.updateNavbarTitle}
								fetchServiceProductsByService={this.props.fetchServiceProductsByService}
								insertServiceProduct={this.props.insertServiceProduct}
								updateServiceProduct={this.props.updateServiceProduct}
								deleteServiceProduct={this.props.deleteServiceProduct}
							/>}
					/>
					<Route
						exact
						path="/services/commandes"
						render={(props) =>
							<ServiceCommandesAll
								{...props}
								features={this.props.features}
								services={this.props.services}
								webapp_users={this.props.webapp_users}
								clients={this.props.clients}
								lang_default={this.props.lang_default}
								fetchReservationsByDateRange={this.props.fetchReservationsByDateRange}
								user={this.props.user}
								serveServiceReservation={this.props.serveServiceReservation}
								payServiceReservation={this.props.payServiceReservation}
								cancelServiceReservation={this.props.cancelServiceReservation}
								updateServiceReservation={this.props.updateServiceReservation}
								submitServiceCart={this.props.submitServiceCart}
								fetchServices={this.props.fetchServices}
								fetchWebappUsers={this.props.fetchWebappUsers}
								fetchClients={this.props.fetchClients}
								fetchServiceBenefits={this.props.fetchServiceBenefits}
								fetchServiceBenefitsByService={this.props.fetchServiceBenefitsByService}
								fetchServiceProductsByService={this.props.fetchServiceProductsByService}
								updateNavbarTitle={this.props.updateNavbarTitle}
							/>}
					/>
					<Route
						exact
						path="/services/commandes/calculatrice"
						render={(props) =>
							<CashCalculator
								{...props}
								features={this.props.features}
								updateNavbarTitle={this.props.updateNavbarTitle}
							/>}
					/>
					<Route
						exact
						path="/services/:id/commandes"
						render={(props) =>
							<ServiceCommandes
								{...props}
								features={this.props.features}
								services={this.props.services}
								webapp_users={this.props.webapp_users}
								clients={this.props.clients}
								lang_default={this.props.lang_default}
								fetchReservationsByDateRange={this.props.fetchReservationsByDateRange}
								user={this.props.user}
								payServiceReservation={this.props.payServiceReservation}
								cancelServiceReservation={this.props.cancelServiceReservation}
								fetchWebappUsers={this.props.fetchWebappUsers}
								fetchClients={this.props.fetchClients}
								fetchServiceBenefitsByService={this.props.fetchServiceBenefitsByService}
								updateNavbarTitle={this.props.updateNavbarTitle}
							/>}
					/>
					<Route
						exact
						path="/services/:id"
						render={(props) =>
							<ServiceDetail
								{...props}
								user={this.props.user}
								lang_default={this.props.lang_default}
								langs={this.props.langs}
								fetchServices={this.props.fetchServices}
								fetchServiceBenefitsByService={this.props.fetchServiceBenefitsByService}
								fetchServiceWorkersByService={this.props.fetchServiceWorkersByService}
								insertServiceBenefit={this.props.insertServiceBenefit}
								insertServiceWorker={this.props.insertServiceWorker}
								updateServiceBenefit={this.props.updateServiceBenefit}
								deleteServiceBenefit={this.props.deleteServiceBenefit}
								deleteServiceWorker={this.props.deleteServiceWorker}
								updateServiceWorker={this.props.updateServiceWorker}
								updateService={this.props.updateService}
								insertPicture={this.props.insertPicture}
								fetchIcons={this.props.fetchIcons}
								fetchTheme={this.props.fetchTheme}
								fetchStripeStatus={this.props.fetchStripeStatus}
								updateNavbarTitle={this.props.updateNavbarTitle}
								fetchServiceProductsByService={this.props.fetchServiceProductsByService}
								insertServiceProduct={this.props.insertServiceProduct}
								updateServiceProduct={this.props.updateServiceProduct}
								deleteServiceProduct={this.props.deleteServiceProduct}
								reorderServiceProducts={this.props.reorderServiceProducts}
							/>}
					/>
					<Route
						exact
						path="/services"
						render={(props) =>
							<Services
								{...props}
								icons={this.props.icons}
								features={this.props.features}
								langs={this.props.langs}
								lang_default={this.props.lang_default}
								service_benefits={this.props.service_benefits}
								service_products={this.props.service_products}
								service_workers={this.props.service_workers}
								services={this.props.services}
								user={this.props.user}
								insertService={this.props.insertService}
								insertServiceBenefit={this.props.insertServiceBenefit}
								insertServiceProduct={this.props.insertServiceProduct}
								insertServiceWorker={this.props.insertServiceWorker}
								updateService={this.props.updateService}
								updateServiceBenefit={this.props.updateServiceBenefit}
								updateServiceDuration={this.props.updateServiceDuration}
								updateServiceProduct={this.props.updateServiceProduct}
								updateServiceWorker={this.props.updateServiceWorker}
								fetchIcons={this.props.fetchIcons}
								fetchTheme={this.props.fetchTheme}
								fetchServices={this.props.fetchServices}
								fetchStripeStatus={this.props.fetchStripeStatus}
								fetchServiceBenefitsByService={this.props.fetchServiceBenefitsByService}
								fetchServiceProductsByService={this.props.fetchServiceProductsByService}
								fetchServiceWorkersByService={this.props.fetchServiceWorkersByService}
								deleteService={this.props.deleteService}
								deleteServiceBenefit={this.props.deleteServiceBenefit}
								deleteServiceBenefitsByService={this.props.deleteServiceBenefitsByService}
								deleteServiceProduct={this.props.deleteServiceProduct}
								deleteServiceWorker={this.props.deleteServiceWorker}
								deleteServiceWorkersByService={this.props.deleteServiceWorkersByService}
								deleteServiceReservationsByService={this.props.deleteServiceReservationsByService}
								fetchReservationsByDateRange={this.props.fetchReservationsByDateRange}
								updateNavbarTitle={this.props.updateNavbarTitle}
							/>}
					/>
					<Route
						exact
						path="/menu"
						render={(props) =>
							<Menu
								{...props}
								menu={this.props.menu}
								groups={this.props.groups}
								updateMenu={this.props.updateMenu}
								fetchGroups={this.props.fetchGroups}
								// fetchMenu={this.props.fetchMenu}
								fetchTheme={this.props.fetchTheme}
								fetchIcons={this.props.fetchIcons}
								updateNavbarTitle={this.props.updateNavbarTitle}
								fetchServiceProductsByService={this.props.fetchServiceProductsByService}
								insertServiceProduct={this.props.insertServiceProduct}
								updateServiceProduct={this.props.updateServiceProduct}
								deleteServiceProduct={this.props.deleteServiceProduct}
							/>}
					/>
					<Route
						exact
						path="/users/dashboard"
						render={(props) =>
							<BackUsers
								{...props}
								updateNavbarTitle={this.props.updateNavbarTitle}
								fetchServiceProductsByService={this.props.fetchServiceProductsByService}
								insertServiceProduct={this.props.insertServiceProduct}
								updateServiceProduct={this.props.updateServiceProduct}
								deleteServiceProduct={this.props.deleteServiceProduct}
							/>}
					/>
					<Route
						exact
						path="/users/webapp/:id"
						render={(props) =>
							<WebUsers
								{...props}
								updateNavbarTitle={this.props.updateNavbarTitle}
								fetchServiceProductsByService={this.props.fetchServiceProductsByService}
								insertServiceProduct={this.props.insertServiceProduct}
								updateServiceProduct={this.props.updateServiceProduct}
								deleteServiceProduct={this.props.deleteServiceProduct}
							/>}
					/>
					<Route
						exact
						path="/users/webapp"
						render={(props) =>
							<WebUsers
								{...props}
								updateNavbarTitle={this.props.updateNavbarTitle}
								fetchServiceProductsByService={this.props.fetchServiceProductsByService}
								insertServiceProduct={this.props.insertServiceProduct}
								updateServiceProduct={this.props.updateServiceProduct}
								deleteServiceProduct={this.props.deleteServiceProduct}
							/>}
					/>
					<Route
						exact
						path="/users/clients/:id"
						render={(props) =>
							<Clients
								{...props}
								updateNavbarTitle={this.props.updateNavbarTitle}
								fetchServiceProductsByService={this.props.fetchServiceProductsByService}
								insertServiceProduct={this.props.insertServiceProduct}
								updateServiceProduct={this.props.updateServiceProduct}
								deleteServiceProduct={this.props.deleteServiceProduct}
							/>}
					/>
					<Route
						exact
						path="/users/clients"
						render={(props) =>
							<Clients
								{...props}
								updateNavbarTitle={this.props.updateNavbarTitle}
								fetchServiceProductsByService={this.props.fetchServiceProductsByService}
								insertServiceProduct={this.props.insertServiceProduct}
								updateServiceProduct={this.props.updateServiceProduct}
								deleteServiceProduct={this.props.deleteServiceProduct}
							/>}
					/>
					<Route
						exact
						path="/users/sejours/:id"
						render={(props) =>
							<Stays
								{...props}
								updateNavbarTitle={this.props.updateNavbarTitle}
								fetchServiceProductsByService={this.props.fetchServiceProductsByService}
								insertServiceProduct={this.props.insertServiceProduct}
								updateServiceProduct={this.props.updateServiceProduct}
								deleteServiceProduct={this.props.deleteServiceProduct}
							/>}
					/>
					<Route
						exact
						path="/users/sejours"
						render={(props) =>
							<Stays
								{...props}
								updateNavbarTitle={this.props.updateNavbarTitle}
								fetchServiceProductsByService={this.props.fetchServiceProductsByService}
								insertServiceProduct={this.props.insertServiceProduct}
								updateServiceProduct={this.props.updateServiceProduct}
								deleteServiceProduct={this.props.deleteServiceProduct}
							/>}
					/>
					<Route
						exact
						path="/users"
						render={(props) =>
							<Users
								{...props}
								updateNavbarTitle={this.props.updateNavbarTitle}
								fetchServiceProductsByService={this.props.fetchServiceProductsByService}
								insertServiceProduct={this.props.insertServiceProduct}
								updateServiceProduct={this.props.updateServiceProduct}
								deleteServiceProduct={this.props.deleteServiceProduct}
							/>}
					/>
					<Route
						exact
						path="/emplacements/parametrage"
						render={(props) =>
							<Pitches
								{...props}
								updateNavbarTitle={this.props.updateNavbarTitle}
							/>}
					/>
					{/* Ancienne adresse du paramétrage, rangé sous Emplacements le 25/10/2026 */}
					<Redirect exact from="/administration/emplacements" to="/emplacements/parametrage" />
					<Route
						exact
						path="/administration/utilisateurs"
						render={(props) =>
							<DashboardUsers
								{...props}
								user={this.props.user}
								features={this.props.features}
								updateNavbarTitle={this.props.updateNavbarTitle}
							/>}
					/>
					<Route
						exact
						path="/utilisateurs"
						render={(props) =>
							<NewClients
								{...props}
								user={this.props.user}
								config_pms={this.props.config_pms}
								subscriptions={this.props.subscriptions}
								updateNavbarTitle={this.props.updateNavbarTitle}
								insertRoomlist={this.props.insertRoomlist}
								fetchConfigPms={this.props.fetchConfigPms}
								fetchNotificationSubscriptions={this.props.fetchNotificationSubscriptions}
							/>}
					/>
					<Route
						exact
						path="/administration/parametres"
						render={(props) =>
							<SettingsConfigWebapp
								{...props}
								user={this.props.user}
								background_img={this.props.background_img}
								establishment={this.props.establishment}
								emails_activate={this.props.emails_activate}
								emails_nbdays={this.props.emails_nbdays}
								langs={this.props.langs}
								lang_default={this.props.lang_default}
								webapp_connexion={this.props.webapp_connexion}
								welcome_txt={this.props.welcome_txt}
								application_ouverte={this.props.dashboard_config ? this.props.dashboard_config.application_ouverte : true}
								dashboard_config={this.props.dashboard_config}
								config_pms={this.props.config_pms}
								features={this.props.features}
								updateConfigDashboard={this.props.updateConfigDashboard}
								insertHomeBanner={this.props.insertHomeBanner}
								removeHomeBanner={this.props.removeHomeBanner}
								updateConfig={this.props.updateConfig}
								fetchStripeStatus={this.props.fetchStripeStatus}
								startStripeOnboarding={this.props.startStripeOnboarding}
								triggerStripePayout={this.props.triggerStripePayout}
								updateNavbarTitle={this.props.updateNavbarTitle}
								fetchServiceProductsByService={this.props.fetchServiceProductsByService}
								insertServiceProduct={this.props.insertServiceProduct}
								updateServiceProduct={this.props.updateServiceProduct}
								deleteServiceProduct={this.props.deleteServiceProduct}
							/>}
					/>
					<Route
						exact
						path="/administration/features"
						render={(props) =>
							<SettingsConfigAdmin
								{...props}
								user={this.props.user}
								features={this.props.features}
								config_pms={this.props.config_pms}
								fetchDashboardConfig={this.props.fetchDashboardConfig}
								fetchStripePayments={this.props.fetchStripePayments}
								fetchConfigPms={this.props.fetchConfigPms}
								updateConfigDashboard={this.props.updateConfigDashboard}
								updateNavbarTitle={this.props.updateNavbarTitle}
								fetchServiceProductsByService={this.props.fetchServiceProductsByService}
								insertServiceProduct={this.props.insertServiceProduct}
								updateServiceProduct={this.props.updateServiceProduct}
								deleteServiceProduct={this.props.deleteServiceProduct}
							/>}
					/>
					<Route
						exact
						path="/administration/emails"
						render={(props) =>
							<Email
								{...props}
								emails={this.props.emails}
								langs={this.props.langs}
								lang_default={this.props.lang_default}
								user={this.props.user}
								insertEmail={this.props.insertEmail}
								updateEmail={this.props.updateEmail}
								deleteEmail={this.props.deleteEmail}
								fetchEmails={this.props.fetchEmails}
								sendEmail={this.props.sendEmail}
								updateNavbarTitle={this.props.updateNavbarTitle}
								fetchServiceProductsByService={this.props.fetchServiceProductsByService}
								insertServiceProduct={this.props.insertServiceProduct}
								updateServiceProduct={this.props.updateServiceProduct}
								deleteServiceProduct={this.props.deleteServiceProduct}
							/>}
					/>
					<Route
						exact
						path="/administration/auto-email"
						render={(props) =>
							<CronMail
								{...props}
								lang_default={this.props.lang_default}
								user={this.props.user}
								updateNavbarTitle={this.props.updateNavbarTitle}
								fetchServiceProductsByService={this.props.fetchServiceProductsByService}
								insertServiceProduct={this.props.insertServiceProduct}
								updateServiceProduct={this.props.updateServiceProduct}
								deleteServiceProduct={this.props.deleteServiceProduct}
							/>}
					/>
					<Route
						exact
						path="/administration/send-emails"
						render={(props) =>
							<SendEmail
								{...props}
								lang_default={this.props.lang_default}
								user={this.props.user}
								fetchEmails={this.props.fetchEmails}
								updateNavbarTitle={this.props.updateNavbarTitle}
								fetchServiceProductsByService={this.props.fetchServiceProductsByService}
								insertServiceProduct={this.props.insertServiceProduct}
								updateServiceProduct={this.props.updateServiceProduct}
								deleteServiceProduct={this.props.deleteServiceProduct}
							/>}
					/>
					<Route
						exact
						path="/administration/notifications"
						render={(props) =>
							<NotificationHub
								{...props}
								notifications={this.props.notifications}
								cron_notifications={this.props.cron_notifications}
								lang_default={this.props.lang_default}
								user={this.props.user}
								fetchNotifications={this.props.fetchNotifications}
								fetchCronNotifications={this.props.fetchCronNotifications}
								updateNavbarTitle={this.props.updateNavbarTitle}
							/>}
					/>
					<Route
						exact
						path="/avis/formulaires"
						render={(props) =>
							<ReviewsTemplate
								{...props}
								user={this.props.user}
								langs={this.props.langs}
								lang_default={this.props.lang_default}
								review_models={this.props.review_models}
								insertReviewModel={this.props.insertReviewModel}
								updateReviewModel={this.props.updateReviewModel}
								deleteReviewModel={this.props.deleteReviewModel}
								fetchReviewModels={this.props.fetchReviewModels}
								updateNavbarTitle={this.props.updateNavbarTitle}
								fetchServiceProductsByService={this.props.fetchServiceProductsByService}
								insertServiceProduct={this.props.insertServiceProduct}
								updateServiceProduct={this.props.updateServiceProduct}
								deleteServiceProduct={this.props.deleteServiceProduct}
							/>}
					/>
					<Route
						exact
						path="/avis/reponses"
						render={(props) =>
							<ReviewsAnswers
								{...props}
								clients={this.props.clients}
								user={this.props.user}
								reviews={this.props.reviews}
								lang_default={this.props.lang_default}
								fetchClients={this.props.fetchClients}
								postExtractReviews={this.props.postExtractReviews}
								fetchReviewsByType={this.props.fetchReviewsByType}
								fetchWebappUsers={this.props.fetchWebappUsers}
								updateNavbarTitle={this.props.updateNavbarTitle}
								fetchServiceProductsByService={this.props.fetchServiceProductsByService}
								insertServiceProduct={this.props.insertServiceProduct}
								updateServiceProduct={this.props.updateServiceProduct}
								deleteServiceProduct={this.props.deleteServiceProduct}
							/>}
					/>
					<Route
						exact
						path="/themes"
						render={(props) =>
							<Theme
								{...props}
								updateNavbarTitle={this.props.updateNavbarTitle}
								fetchServiceProductsByService={this.props.fetchServiceProductsByService}
								insertServiceProduct={this.props.insertServiceProduct}
								updateServiceProduct={this.props.updateServiceProduct}
								deleteServiceProduct={this.props.deleteServiceProduct}
							/>}
					/>
					<Route
						exact
						path="/stats"
						render={(props) =>
							<Stats
								{...props}
								user={this.props.user}
								updateNavbarTitle={this.props.updateNavbarTitle}
								fetchStatsOverview={this.props.fetchStatsOverview}
							/>}
					/>
					<Route
						exact
						path="/inventaires"
						render={(props) =>
							<Inventory
								{...props}
								user={this.props.user}
								accommodations={this.props.accommodations}
								features={this.props.features}
								langs={this.props.langs}
								lang_default={this.props.lang_default}
								fetchAccommodations={this.props.fetchAccommodations}
								fetchConfigInventory={this.props.fetchConfigInventory}
								insertAccommodation={this.props.insertAccommodation}
								insertAccommodationDuplicate={this.props.insertAccommodationDuplicate}
								updateAccommodation={this.props.updateAccommodation}
								updateAccommodationLocationCategoryList={this.props.updateAccommodationLocationCategoryList}
								updateConfigInventory={this.props.updateConfigInventory}
								updateInventoryEmptyList={this.props.updateInventoryEmptyList}
								deleteAccommodation={this.props.deleteAccommodation}
								updateNavbarTitle={this.props.updateNavbarTitle}
								fetchServiceProductsByService={this.props.fetchServiceProductsByService}
								insertServiceProduct={this.props.insertServiceProduct}
								updateServiceProduct={this.props.updateServiceProduct}
								deleteServiceProduct={this.props.deleteServiceProduct}
							/>}
					/>
					<Route
						exact
						path="/emplacements"
						render={(props) =>
							<LocationsPage
								{...props}
								user={this.props.user}
								pitches={this.props.pitches}
								updateNavbarTitle={this.props.updateNavbarTitle}
							/>}
					/>
					<Route
						exact
						path="/inventaires/checkin"
						render={(props) =>
							<Inventories
								{...props}
								user={this.props.user}
								features={this.props.features}
								lang_default={this.props.lang_default}
								inventories={this.props.inventories}
								insertInventory={this.props.insertInventory}
								updateInventoryComment={this.props.updateInventoryComment}
								updateInventoryPictures={this.props.updateInventoryPictures}
								deleteInventoryPicture={this.props.deleteInventoryPicture}
								fetchConfigInventory={this.props.fetchConfigInventory}
								fetchInventories={this.props.fetchInventories}
								fetchInventoryBySearch={this.props.fetchInventoryBySearch}
								fetchInventoryByStayNb={this.props.fetchInventoryByStayNb}
								updateNavbarTitle={this.props.updateNavbarTitle}
								fetchServiceProductsByService={this.props.fetchServiceProductsByService}
								insertServiceProduct={this.props.insertServiceProduct}
								updateServiceProduct={this.props.updateServiceProduct}
								deleteServiceProduct={this.props.deleteServiceProduct}
							/>}
					/>
					<Route
						exact
						path="/checkins/arrivals"
						render={(props) =>
						{
							const perm = this.props.user && this.props.user.permissions
							if (!perm || !perm.precheckins || perm.precheckins === 0)
								return <Redirect to="/" />
							return (
								<StayArrivals
									{...props}
									fetchArrivals={this.props.fetchArrivals}
									fetchArrivalCounts={this.props.fetchArrivalCounts}
									notifyLocationReady={this.props.notifyLocationReady}
									updateLocationReady={this.props.updateLocationReady}
									updateOnsite={this.props.updateOnsite}
									updateLinenField={this.props.updateLinenField}
									updateJacuzzi={this.props.updateJacuzzi}
									updateCheckDone={this.props.updateCheckDone}
									updateArrivalDashboard={this.props.updateArrivalDashboard}
									updateLocation={this.props.updateLocation}
									pitches={this.props.pitches}
									fetchPitches={this.props.fetchPitches}
									updateNavbarTitle={this.props.updateNavbarTitle}
									config_checkins={this.props.config_checkins}
									fetchConfigCheckins={this.props.fetchConfigCheckins}
									config_pms={this.props.config_pms}
								/>
							)
						}}
					/>
					<Route
						exact
						path="/checkins/stats"
						render={(props) =>
							<CheckinsStats
								{...props}
								updateNavbarTitle={this.props.updateNavbarTitle}
								fetchArrivals={this.props.fetchArrivals}
							/>}
					/>
					<Route
						exact
						path="/checkins/config"
						render={(props) =>
						{
							const perm = this.props.user && this.props.user.permissions
							if (!perm || !perm.precheckins || perm.precheckins === 0)
								return <Redirect to="/" />
							return (
								<CheckinsParam
									{...props}
									updateNavbarTitle={this.props.updateNavbarTitle}
									config_checkins={this.props.config_checkins}
									fetchConfigCheckins={this.props.fetchConfigCheckins}
									updateConfigCheckins={this.props.updateConfigCheckins}
									config_pms={this.props.config_pms}
									fetchConfigPms={this.props.fetchConfigPms}
									updateConfigPms={this.props.updateConfigPms}
									langs={this.props.langs}
									lang_default={this.props.lang_default}
								/>
							)
						}}
					/>
					<Route
						exact
						path="/deposit/swikly"
						render={(props) =>
							<DepositParam
								{...props}
								updateNavbarTitle={this.props.updateNavbarTitle}
								fetchAccommodations={this.props.fetchAccommodations}
								fetchConfigDeposit={this.props.fetchConfigDeposit}
								updateAccommodationDeposit={this.props.updateAccommodationDeposit}
								updateConfigDeposit={this.props.updateConfigDeposit}
							/>}
					/>
					<Route
						exact
						path="/deposit/users-deposit"
						render={(props) =>
							<UsersDeposit
								{...props}
								user={this.props.user}
								deposits={this.props.deposits}
								fetchDeposits={this.props.fetchDeposits}
								updateNavbarTitle={this.props.updateNavbarTitle}
								fetchServiceProductsByService={this.props.fetchServiceProductsByService}
								insertServiceProduct={this.props.insertServiceProduct}
								updateServiceProduct={this.props.updateServiceProduct}
								deleteServiceProduct={this.props.deleteServiceProduct}
							/>}
					/>
					<Route
						exact
						path="/inventaires/edit/:id"
						render={(props) =>
							<InventoryEdit
								{...props}
								langs={this.props.langs}
								lang_default={this.props.lang_default}
								accommodations={this.props.accommodations}
								fetchAccommodationByID={this.props.fetchAccommodationByID}
								insertInventoryCategory={this.props.insertInventoryCategory}
								insertInventoryObjects={this.props.insertInventoryObjects}
								updateInventoryCategory={this.props.updateInventoryCategory}
								deleteInventoryCategory={this.props.deleteInventoryCategory}
								updateNavbarTitle={this.props.updateNavbarTitle}
								fetchServiceProductsByService={this.props.fetchServiceProductsByService}
								insertServiceProduct={this.props.insertServiceProduct}
								updateServiceProduct={this.props.updateServiceProduct}
								deleteServiceProduct={this.props.deleteServiceProduct}
							/>}
					/>
					<Route
						exact
						path="/messages/chat"
						render={(props) =>
							<MessagerieAll
								{...props}
								features={this.props.features}
								conversations={this.props.conversations}
								fetchConversations={this.props.fetchConversations}
								pollConversations={this.props.pollConversations}
								pollMessagesByConversation={this.props.pollMessagesByConversation}
								fetchMessagesByConversation={this.props.fetchMessagesByConversation}
								insertStaffMessage={this.props.insertStaffMessage}
								fetchConversationNotes={this.props.fetchConversationNotes}
								insertConversationNote={this.props.insertConversationNote}
								deleteConversationNote={this.props.deleteConversationNote}
								insertIntervention={this.props.insertIntervention}
								updateConversationDashboard={this.props.updateConversationDashboard}
								webapp_users={this.props.webapp_users}
								fetchWebappUsers={this.props.fetchWebappUsers}
								pitches={this.props.pitches}
								fetchPitches={this.props.fetchPitches}
								user={this.props.user}
								dashboard_users={this.props.dashboard_users}
								fetchDashboardUsers={this.props.fetchDashboardUsers}
								updateNavbarTitle={this.props.updateNavbarTitle}
								sidebar_collapsed={this.props.sidebar_collapsed}
							/>}
					/>
					<Route
						exact
						path="/messages/config"
						render={(props) =>
							<MessagerieParam
								{...props}
								features={this.props.features}
								updateNavbarTitle={this.props.updateNavbarTitle}
								config_messages={this.props.config_messages}
								fetchConfigMessages={this.props.fetchConfigMessages}
								updateConfigMessages={this.props.updateConfigMessages}
								lang_default={this.props.lang_default}
							/>}
					/>
					<Route
						exact
						path="/pdf"
						render={(props) =>
							<Pdf
								{...props}
								updateNavbarTitle={this.props.updateNavbarTitle}
								files={this.props.files}
								insertPdf={this.props.insertPdf}
								insertPicture={this.props.insertPicture}
								deletePdf={this.props.deletePdf}
								deletePicture={this.props.deletePicture}
								fetchFiles={this.props.fetchFiles}
							/>}
					/>
					<Route
						path="/"
						render={(props) =>
							<Home
								{...props}
								user={this.props.user}
								features={this.props.features}
								langs={this.props.langs}
								lang_default={this.props.lang_default}
								pages={this.props.pages}
								groups={this.props.groups}
								categories={this.props.categories}
								fetchCategories={this.props.fetchCategories}
								fetchGroups={this.props.fetchGroups}
								fetchPages={this.props.fetchPages}
								fetchWebappConfig={this.props.fetchWebappConfig}
								fetchArrivals={this.props.fetchArrivals}
								fetchHomeStats={this.props.fetchHomeStats}
								fetchReservationsByDateRange={this.props.fetchReservationsByDateRange}
								fetchAnimations={this.props.fetchAnimations}
								fetchAnimationDates={this.props.fetchAnimationDates}
								fetchServiceBenefits={this.props.fetchServiceBenefits}
								fetchReviewsByType={this.props.fetchReviewsByType}
								updateNavbarTitle={this.props.updateNavbarTitle}
								sendNotifications={this.props.sendNotifications}
								conversations={this.props.conversations}
								fetchConversations={this.props.fetchConversations}
							/>}
					/>
				</Switch>
		</div>
				)}
			</Route>
		)
	}
}

export default Main
